"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGoalByMapNameAndTypeDTO = exports.GetGoalsByMapNameDTO = exports.GoalListDTO = exports.GoalNameDTO = exports.GoalDTO = exports.GoalsNames = exports.MatchMakingGoals = exports.PlaceDefenseGoals = exports.PlaceUpgradeGoals = exports.PlaceAttackPvPGoals = exports.PlaceAttackPvEGoals = exports.QuestGoals = void 0;
const class_validator_1 = require("class-validator");
const Battle_1 = require("./Battle");
var QuestGoals;
(function (QuestGoals) {
    QuestGoals["BossLair"] = "BossLair";
    QuestGoals["RescueMission"] = "RescueMission";
    QuestGoals["EscortMission"] = "EscortMission";
    QuestGoals["OutOfGas"] = "OutOfGas";
    QuestGoals["LoneSurvivor"] = "LoneSurvivor";
    QuestGoals["GroceriesDay"] = "GroceriesDay";
    QuestGoals["TheWall"] = "TheWall";
    QuestGoals["RunForIt"] = "RunForIt";
    QuestGoals["Infiltration"] = "Infiltration";
    QuestGoals["Ambush"] = "Ambush";
    QuestGoals["Onboarding"] = "Onboarding";
})(QuestGoals = exports.QuestGoals || (exports.QuestGoals = {}));
var PlaceAttackPvEGoals;
(function (PlaceAttackPvEGoals) {
    PlaceAttackPvEGoals["ConquerFortify"] = "ConquerFortify";
    PlaceAttackPvEGoals["ActivatePowerGrid"] = "ActivatePowerGrid";
})(PlaceAttackPvEGoals = exports.PlaceAttackPvEGoals || (exports.PlaceAttackPvEGoals = {}));
var PlaceAttackPvPGoals;
(function (PlaceAttackPvPGoals) {
    PlaceAttackPvPGoals["Sabotage"] = "Sabotage";
    PlaceAttackPvPGoals["ZoneCapture"] = "ZoneCapture";
    PlaceAttackPvPGoals["PowerSourceGathering"] = "PowerSourceGathering";
    PlaceAttackPvPGoals["GeneratorsRace"] = "GeneratorsRace";
})(PlaceAttackPvPGoals = exports.PlaceAttackPvPGoals || (exports.PlaceAttackPvPGoals = {}));
var PlaceUpgradeGoals;
(function (PlaceUpgradeGoals) {
    PlaceUpgradeGoals["Ambush"] = "Ambush";
})(PlaceUpgradeGoals = exports.PlaceUpgradeGoals || (exports.PlaceUpgradeGoals = {}));
var PlaceDefenseGoals;
(function (PlaceDefenseGoals) {
    PlaceDefenseGoals["BossAssault"] = "BossAssault";
    PlaceDefenseGoals["StandYourGround"] = "StandYourGround";
    PlaceDefenseGoals["ReactivatePowerGrid"] = "ReactivatePowerGrid";
    PlaceDefenseGoals["RepairDefenses"] = "RepairDefenses";
})(PlaceDefenseGoals = exports.PlaceDefenseGoals || (exports.PlaceDefenseGoals = {}));
var MatchMakingGoals;
(function (MatchMakingGoals) {
    MatchMakingGoals["CrowdFavorite"] = "CrowdFavorite";
})(MatchMakingGoals = exports.MatchMakingGoals || (exports.MatchMakingGoals = {}));
exports.GoalsNames = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, QuestGoals), PlaceAttackPvEGoals), PlaceAttackPvPGoals), PlaceDefenseGoals), MatchMakingGoals), PlaceUpgradeGoals);
class GoalDTO {
}
exports.GoalDTO = GoalDTO;
class GoalNameDTO {
}
exports.GoalNameDTO = GoalNameDTO;
class GoalListDTO {
}
exports.GoalListDTO = GoalListDTO;
let GetGoalsByMapNameDTO = (() => {
    class GetGoalsByMapNameDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], GetGoalsByMapNameDTO.prototype, "mapName", void 0);
    return GetGoalsByMapNameDTO;
})();
exports.GetGoalsByMapNameDTO = GetGoalsByMapNameDTO;
let GetGoalByMapNameAndTypeDTO = (() => {
    class GetGoalByMapNameAndTypeDTO extends GetGoalsByMapNameDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Battle_1.BattleContext),
        __metadata("design:type", String)
    ], GetGoalByMapNameAndTypeDTO.prototype, "compatibleContext", void 0);
    return GetGoalByMapNameAndTypeDTO;
})();
exports.GetGoalByMapNameAndTypeDTO = GetGoalByMapNameAndTypeDTO;
//# sourceMappingURL=Goal.js.map